<template>
  <div class="multi-checkbox-container" :style="{ gap: gap }">
    <label
      v-for="item in items"
      :key="item.value"
      class="checkbox-wrap"
      :class="{ 'two-columned': twoColumned, disabled: item.disabled }"
    >
      <input
        type="checkbox"
        :id="toKebabCase(item.value)"
        :name="toKebabCase(item.value)"
        :disabled="item.disabled"
        :checked="value.includes(item.value)"
        @change="toggleValue(item.value)"
      />
      {{ item.label }}
    </label>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  props: {
    items: {
      type: Array,
      validator: prop => {
        return prop.every(e => {
          const nameIsValid = typeof e.value == 'string'
          const labelIsValid = typeof e.label == 'string'
          const valid = nameIsValid && labelIsValid
          if (!valid) {
            console.error('The prop "items" must include objects with a .name and .label property.')
          }
          return valid
        })
      },
    },
    value: { type: Array, default: () => [] },
    twoColumned: { type: Boolean, default: true },
    gap: { type: String, default: '0.75rem' },
  },
  mixins: [stringUtils],
  methods: {
    toggleValue(itemValue) {
      const newValue = this.value

      if (newValue.includes(itemValue)) {
        newValue.splice(newValue.indexOf(itemValue), 1)
      } else {
        newValue.push(itemValue)
      }

      this.$emit('input', newValue)
    },
  },
}
</script>

<style lang="scss">
@import './Checkbox.scss';

.multi-checkbox-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .two-columned {
    flex: 49%;
  }
}
</style>
